<template>
  <div class="includeHeder-main">
    <div
      style="display: none"
      class="top-header-mobile p-2 d-flex align-items-center justify-content-between"
    >
      <div class="logoTop-mob">
        <img src="../../../../static/fxView/images/logo.svg" />
      </div>
      <div class="mobTop-menu">
        <div class="navbar-light">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>
    <div
      class="top-sidebar-header d-flex align-items-center justify-content-between"
    >
      <div class="pagetitle d-none d-xl-block">
        <h4>{{ nameFunction(pageName) }}</h4>
      </div>
      <div class="togggleResponsivemenu d-xl-none">
        <button class="navbar-toggler" @click.prevent="addRemClass()">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <!-- <div>
          <select
            @change="changeOrigin"
            v-model="selectedOrigin"
            class="custom-select"
          >
            <option value="svg">SVG</option>
            <option value="eu">EU</option>
          </select>
        </div> -->
        <div class="rightmenu d-flex align-items-center justify-content-end">
          <!--  <div class="verificationstatus">
                        <span class="grd_btn grd_red d-flex align-items-center" v-if="parseInt(get_user.step) > 2 && parseInt(get_user.verified_status) == 0"><feather type="bar-chart"></feather> Documents under verification</span>
                        <router-link class="grd_btn grd_red" title="Dashboard" :to="'/complete-steps'" v-if="parseInt(get_user.step) <= 2">
                            <span>Please complete registeration steps</span>
                        </router-link>
                    </div> -->
          <!-- <div class="dropdown headerNot-mob border-left ml-3">
            <button
              class="btn dropdown-toggle pr-5"
              id="menu1"
              type="button"
              @click.prevent="showClass = !showClass"
            >
              <div class="user-header d-flex align-items-center">
                {{ get_user.username.charAt(0) || get_user.email.charAt(0)}}
              </div>
              <span class="caret"></span>
            </button>
            <ul
              class="dropdown-menu user p-0"
              role="menu"
              :class="showClass ? 'show' : ''"
            >
              <li>
                <div
                  class="customDropdownHead d-flex align-items-center text-left"
                >
                  <div class="headTitle">
                    <div class="bold">
                      <div class="user_verification">
                        <span
                          class="alertLT not_verified"
                          v-if="parseInt(get_user.verified_status) == 1"
                          >Verified
                        </span>
                        <span class="alertLT not_verified" v-else
                          >Unverified</span
                        >
                      </div>
                    </div>
                    <span class="email">{{ get_user.email }}</span>
                  </div>
                </div>
              </li>
              <li role="presentation">
                <a
                  href="#"
                  title="Dashboard"
                  @click.prevent="showClassFunc('/profile')"
                  >Profile</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#"
                  title="Security"
                  @click.prevent="showClassFunc('/security')"
                  >Security</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#"
                  title="Change Password"
                  @click.prevent="showClassFunc('/change-password')"
                  >Change Password</a
                >
              </li>

              <li role="presentation">
                <a
                  role="menuitem"
                  tabindex="-1"
                  href="#"
                  @click.prevent="
                    showClass = false;
                    logout();
                  "
                  >Logout</a
                >
              </li>
            </ul>
          </div> -->
          <div class="dropdown headerNot-mob border-left ml-3">
            <button
              class="btn dropdown-toggle pr-5"
              id="menu1"
              type="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            >
              <div class="user-header d-flex align-items-center">
                {{ get_user.username.charAt(0) || get_user.email.charAt(0)}}
              </div>
              <span class="caret"></span>
            </button>
            <ul
              class="dropdown-menu user p-0"
              role="menu"
              aria-labelledby="menu1"
            >
              <li>
                <div
                  class="customDropdownHead d-flex align-items-center text-left"
                >
                  <div class="headTitle">
                    <div class="bold">
                      <div class="user_verification">
                        <span
                          class="alertLT verified"
                          v-if="parseInt(get_user.verified_status) == 1"
                          >Verified
                        </span>
                        <span class="alertLT not_verified" v-else
                          >Unverified</span
                        >
                      </div>
                    </div>
                    <span class="email">{{ get_user.email }}</span>
                  </div>
                </div>
              </li>
              <li role="presentation">
                <a
                  href="#"
                  title="Dashboard"
                  @click.prevent="showClassFunc('/profile')"
                  >Profile</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#"
                  title="Security"
                  @click.prevent="showClassFunc('/security')"
                  >Security</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#"
                  title="Change Password"
                  @click.prevent="showClassFunc('/change-password')"
                  >Change Password</a
                >
              </li>

              <li role="presentation">
                <a
                  role="menuitem"
                  tabindex="-1"
                  href="#"
                  @click.prevent="
                    showClass = false;
                    logout();
                  "
                  >Logout</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import * as types from "@/types";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      message: "",
      showClass: false,
      selectedOrigin: "svg",
    };
  },
  mixins: [fxViewMixins],
  props: ["pageName", "msz", "msz_type"],
  watch: {
    $route(to, from) {
      if ($(document.body).hasClass("openMob-menu")) {
        $(document.body).removeClass("openMob-menu");
      }
    },
  },
  created() {
    this.selectedOrigin = window.localStorage.getItem("ib-origin")
      ? window.localStorage.getItem("ib-origin")
      : "svg";
  },
  methods: {
    changeOrigin(event) {
      window.localStorage.setItem("ib-origin", event.target.value);
      this.$router.go(this.$router.currentRoute);
      // if(event.target.value == 'eu'){
      //   this.$env_var.cpLink = 'https://app.fxview.com/'
      // }else{
      //   this.$env_var.cpLink = 'https://global.fxview.com/'
      // }
    },
    showClassFunc(getPath) {
      this.showClass = false;
      this.$router.replace(getPath);
    },
    addRemClass() {
      if ($(document.body).hasClass("openMob-menu")) {
        $(document.body).removeClass("openMob-menu");
      } else {
        $(document.body).addClass("openMob-menu");
      }
    },
    nameFunction(getData) {
      let nameString = "";
      return getData;
      // let name_array = getData.split('-');
      // for(let i=0 ; i<=name_array.length -1 ; i++){
      //     nameString = nameString +' '+name_array[i]

      //     if(i == name_array.length -1){
      //         return nameString;
      //     }
      // }
    },
    ...mapActions({
      _runUserLogout: types.RUN_USER_LOGOUT,
    }),
    logout() {
      // const r = this.$router
      // this._runLogout({
      //     router: r,
      //     parameter: this
      // })
      const _that = this;
      let input_json = {
        globalParams: {},
        localParams: {
          parameter: _that,
        },
      };
      _that._runUserLogout(input_json);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/header.vue